export default {
  id: null,
  nome: null,
  tipo: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/campaignlistmodel.js